<table class="control-table">
    <tbody>
        <tr
            *ngFor="let row of controls; trackBy: trackIndex"
            class="control-table-row"
        >
            <td
                *ngFor="let cell of row.cells; trackBy: trackCellId"
                class="control-table-cell"
                [class.align-bottom]="cell.alignBottom"
                [attr.colspan]="cell.control?.columnSpan"
                [attr.rowspan]="cell.control?.rowSpan"
            >
                <ng-container #controlGridCell></ng-container>
            </td>
        </tr>
    </tbody>
</table>
